<template>
  <div
    class="relative flex min-h-screen flex-col justify-between bg-gradient-to-b from-main-bg to-ocean"
  >
    <slot />
  </div>
</template>
